export const STATUS = {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    ERROR: 500,
}

export const USER_TYPES = {
    STUDENT: 'student',
    STAFF: 'staff',
    ADMIN: 'admin'
};

export const USER_ROLES = {
    student: 'Học sinh',
    teacher: 'Giáo viên',
    student_management: 'Quản sinh',
    branch_management: 'Quản lý chi nhánh',
    admin: 'Admin',
} as const

export type UserRole = keyof typeof USER_ROLES


export type UserRoleKey = keyof typeof USER_ROLES

export const GENDERS = {
    MALE: 'male',
    FEMALE: 'female',
    OTHER: 'other'
};

export const GENDERS_FORMAT = {
    male: 'nam',
    female: 'nữ',
    other: 'khác'
};

export type Gender = 'male' | 'female' | 'other';

export type UserStatus = "active" | "inactive" | "pending";

export const STATUS_USER: Record<UserStatus, string> = {
    active: "active",
    inactive: "inactive",
    pending: "pending",
};

export type StudentType = {
    id: number;
    fullName: string;
    gender: Gender;
    dateOfBirth: string;
    email?: string;
    phoneNumber?: string;
    address?: string;
    status: UserStatus;
    student?: {
        schoolGrade?: string;
    };
}

export const STATUS_STUDENT: Record<UserStatus, string> = {
    active: "Đang học",
    inactive: "Nghỉ học",
    pending: "Đang chờ",
};

export const STATUS_STAFF: Record<UserStatus, string> = {
    active: "Đang làm",
    inactive: "Đã nghỉ",
    pending: "Đang chờ",
};

export const STATUS_USER_COMMON: Record<UserStatus, string> = {
    active: "Đang hoạt động",
    inactive: "Không hoạt động",
    pending: "Đang chờ",
};

export const ACADEMIC_TITLES = {
    PROFRESSOR: 'Giáo sư',
    ASSOCIATE_PROFRESSOR: 'Phó giáo sư'
};

export const DEGREES = {
    STUDENT: 'Sinh viên',
    BACHELOR: 'Cử nhân',
    MASTER: 'Thạc sĩ',
    DOCTOR: 'Tiến sĩ'
};

export const STAFF_TYPES = {
    TEACHER: 'teacher',
    BRANCH_MANAGER: 'branch_manager',
    STUDENT_MANAGEMENT: 'student_management'
};

export const ADMIN_TYPES = {
    SUPER_ADMIN: 'super_admin',
    CONTENT_ADMIN: 'content_admin'
};

export const ROLES = {
    STUDENT: 'student',
    STAFF: 'staff',
    ADMIN: 'admin',
    TEACHER: 'teacher',
    BRANCH_MANAGER: 'branch_manager',
    STUDENT_MANAGEMENT: 'student_management'
};

export const BRANCHES = {
    "branch_1": 'Cơ sở 1 - Phường Bình Dương',
    "branch_2": 'Cơ sở 2 - Phường Phú Lợi',
    "branch_3": 'Cơ sở 3 - Phường Phú An',
    "branch_4": 'Cơ sở 4 - Phường Tân Khánh',
    "branch_5": 'Cơ sở 5 - Phường An Phú',
    "branch_6": 'Cơ sở 6 - Phường Hòa Lợi',
    "branch_7": 'Cơ sở 7 - Học online',
};

export const COURSES = {
    "course_1": 'Tiền Tiểu Học',
    "course_2": 'Toán - Tiếng Việt - Tiếng Anh (Cấp 1)',
    "course_3": 'Toán - Ngữ Văn - Tiếng Anh - KHTN (Cấp 2)',
    "course_4": 'Toán - Lý - Hóa - Văn - Anh (Cấp 3)',
    "course_5": 'Tin học ứng dụng',
};

export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB

export const gradeListSelect = [
    { value: "1", label: "Lớp 1" },
    { value: "2", label: "Lớp 2" },
    { value: "3", label: "Lớp 3" },
    { value: "4", label: "Lớp 4" },
    { value: "5", label: "Lớp 5" },
    { value: "6", label: "Lớp 6" },
    { value: "7", label: "Lớp 7" },
    { value: "8", label: "Lớp 8" },
    { value: "9", label: "Lớp 9" },
    { value: "10", label: "Lớp 10" },
    { value: "11", label: "Lớp 11" },
    { value: "12", label: "Lớp 12" },
    { value: "13", label: "Khác" },
]

export const branchListSelect = [
    { value: "branch_1", label: "Cơ sở 1 - Phường Bình Dương" },
    { value: "branch_2", label: "Cơ sở 2 - Phường Phú Lợi" },
    { value: "branch_3", label: "Cơ sở 3 - Phường Phú An" },
    { value: "branch_4", label: "Cơ sở 4 - Phường Tân Khánh" },
    { value: "branch_5", label: "Cơ sở 5 - Phường An Phú" },
    { value: "branch_6", label: "Cơ sở 6 - Phường Hòa Lợi" },
    { value: "branch_7", label: "Học online" },
]

export const BRANCH_LIST_FORMAT = {
    "branch_1": "Cơ sở 1 - Phường Bình Dương",
    "branch_2": "Cơ sở 2 - Phường Phú Lợi",
    "branch_3": "Cơ sở 3 - Phường Phú An",
    "branch_4": "Cơ sở 4 - Phường Tân Khánh",
    "branch_5": "Cơ sở 5 - Phường An Phú",
    "branch_6": "Cơ sở 6 - Phường Hòa Lợi",
    "branch_7": "Học online",
}

export type BranchCode = keyof typeof BRANCH_LIST_FORMAT



export const courseListSelect = [
    { value: "course_1", label: "Tiền tiểu học" },
    { value: "course_2", label: "Toán - Tiếng Việt - Tiếng Anh (Cấp 1)" },
    { value: "course_3", label: "Toán - Ngữ Văn - Tiếng Anh - KHTN (Cấp 2)" },
    { value: "course_4", label: "Toán - Lý - Hóa - Văn - Anh (Cấp 3)" },
    { value: "course_5", label: "Tin học ứng dụng" },
]

export const subjectListSelect = [
    { value: "subject_1", label: "Toán" },
    { value: "subject_2", label: "Tiếng Việt" },
    { value: "subject_3", label: "Tiếng Anh" },
    { value: "subject_4", label: "Khoa Học Tự Nhiên" },
]

export const roleListSelect = [
    { value: "teacher", label: "Giáo viên" },
    { value: "branch_manager", label: "Quản lý chi nhánh" },
    { value: "student_management", label: "Quản sinh" },
    { value: "marketing", label: "Marketing" },
    { value: "sale", label: "Sale" },
    { value: "accountant", label: "Kế toán" },
]

export const genderListSelect = [
    { value: "male", label: "Nam" },
    { value: "female", label: "Nữ" },
    { value: "other", label: "Khác" },
]

export const typeAdminListSelect = [
    { value: "super_admin", label: "Super Admin" },
    { value: "content_admin", label: "Content Admin" },
]

export const dayOfWeekListSelect = {
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday',
}

export const listStatus = [
    {
        value: 'active',
        label: 'Đang hoạt động'
    },
    {
        value: 'pending',
        label: 'Đang chờ'
    }, {
        value: 'inactive',
        label: 'Không hoạt động'
    },
]

export const events = [
    {
        date: "15/08/2023",
        icon: "fa-graduation-cap",
        title: "Đăng ký nhập học",
        desc: "Học sinh đăng ký khóa học Toán - Tiếng Việt - Tiếng Anh lớp 3",
    },
    {
        date: "20/08/2023",
        icon: "fa-book-open",
        title: "Bắt đầu khóa học",
        desc: "Bắt đầu học chương trình chính thức",
    },
    {
        date: "15/10/2023",
        icon: "fa-chart-line",
        title: "Đánh giá giữa kỳ",
        desc: "Kết quả: Xuất sắc - Điểm trung bình: 9.2",
    },
    {
        date: "Hiện tại",
        icon: "fa-award",
        title: "Đang học",
        desc: "Tiếp tục chương trình học kỳ II",
    },
];